import { MonthPicker } from '@mantine/dates';
import { useTranslation } from 'react-i18next';
import { IJxtMonthPicker } from './types';
import { reverseLangMapping } from '@jooxter/i18n';
import { calendarCardClassNames, calendarClassNames } from '../JxtDatePicker/classNames';
import JxtMantineProvider from '../JxtMantineProvider';

const JxtMonthPicker = ({ initialDate, onDateChange }: IJxtMonthPicker) => {
  const { i18n } = useTranslation();

  return (
    <JxtMantineProvider>
      <MonthPicker
        onChange={(date) => date && onDateChange(date)}
        defaultDate={initialDate}
        value={initialDate}
        withCellSpacing={false}
        locale={reverseLangMapping[i18n.language]}
        classNames={{ ...calendarClassNames, ...calendarCardClassNames }}
      />
    </JxtMantineProvider>
  );
};

export default JxtMonthPicker;
